import { createContext } from 'react';

import type { AdminApiEndpoints } from './api.endpoints';

export interface ApiContextValue {
    api?: AdminApiEndpoints;
}

export const ApiContext = createContext<ApiContextValue>({
    api: undefined
});
